<template>
	<div :class="{'eb-card': home}">
		<div v-if="home" class="eb-card eb-card-collapsible">
			<EbHeading level="h2">Mes informations aux parents</EbHeading>
      <EbLinkButton v-if="!isMobile" :to="{name: 'infosParents'}" class="eb-card-button primary small">Modifier<span class="sr-only"> mes informations aux parents</span></EbLinkButton>
			<div class="md:grid md:grid-cols-3 md:col-span-2 md:gap-16">
				<div>
					<h3>Ma présentation</h3>
					<p v-if="infos && infos.presentation.presentation">{{ presentation }}</p>
					<p v-else>Vous n’avez renseigné aucune présentation.</p>
				</div>
				
				<div>
					<h3>Me contacter</h3>
					<div v-if="infos && (infos.coordonnees.numeroTelephoneFixe || infos.coordonnees.numeroTelephonePortable || infos.coordonnees.courriel || infos.coordonnees.precisionsModalitesContact)">
						<p v-if="infos.coordonnees.numeroTelephoneFixe">Téléphone fixe&nbsp;: <br />{{ infos.coordonnees.numeroTelephoneFixe }}</p>
						<p v-if="infos.coordonnees.numeroTelephonePortable">Téléphone portable&nbsp;: <br />{{ infos.coordonnees.numeroTelephonePortable }}</p>
						<p v-if="infos.coordonnees.courriel">Courriel&nbsp;: <br />{{ infos.coordonnees.courriel }}</p>
						<p v-if="infos.coordonnees.precisionsModalitesContact">Modalités de contact&nbsp;: <br />{{ infos.coordonnees.precisionsModalitesContact }}</p>
					</div>
					<div v-else>
						<p>Vous n’avez renseigné aucun moyen de contact.</p>
					</div>
				</div>
				
				<div>
					<h3>Mes formations et compétences</h3>
					<div v-if="infos && (infos.presentation.formationsCompetences || infos.presentation.dateObtentionPremierSecours)">
						<p v-if="infos.presentation.dateObtentionPremierSecours"> J'ai une initiation / formation aux premiers secours obtenue le <time :datetime="infos.presentation.dateObtentionPremierSecours">{{ getLongDate(infos.presentation.dateObtentionPremierSecours) }}</time></p>
						<p v-if="infos.presentation.formationsCompetences">{{ infos.presentation.formationsCompetences }}</p>	
					</div>
					<p v-else>Vous n’avez renseigné aucune formation.</p>
				</div>
				
				<div class="eb-card-collapsible-control md:col-span-full">
					<EbLinkButton v-if="isMobile" :to="{name: 'infosParents'}" class="eb-card-button primary small">Modifier<span class="sr-only"> mes informations aux parents</span></EbLinkButton>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="text-right md:flex md:justify-between md:align-items-center">
				<EbHeading v-if="!isMobile && !isSmallScreen" level="h1" class="eb-page-heading">Mes informations aux parents</EbHeading>
				<a :href="publicProfileUrl" class="eb-button secondary small icon-after" target="_blank" rel="noreferrer noopener" title="Voir ma fiche en ligne - Nouvelle fenêtre">Voir ma fiche en ligne <font-awesome-icon :icon="['fas', 'external-link-alt']" /></a>	
			</div>
			<div class="eb-content-default">
				<div v-if="isMobile || isSmallScreen" class="eb-tabs" role="tablist" aria-label="Sommaire des onglets pour mes infos aux parents">
					<button type="button" id="tab-0" class="eb-tabs-item" :class="{active: !isActiveTab}" role="tab" :aria-selected="isActiveIndex == index ? 'true' : 'false'" aria-controls="panel-1" :tabindex="isActiveIndex == index ? '0' : '-1'" @click="toggleTab">Présentation</button>
					<button type="button" id="tab-4" class="eb-tabs-item" :class="{active: isActiveTab}" role="tab" :aria-selected="isActiveIndex == index ? 'true' : 'false'" aria-controls="panel-4" :tabindex="isActiveIndex == index ? '0' : '-1'" @click="toggleTab">Modalités d'accueil</button>
				</div>
				<EbTabs v-else ariaLabel="Sommaire des onglets pour mes infos aux parents" :tabs="[{name: 'Ma présentation'}, {name: 'Me contacter'}, {name: 'Mes formations et compétences'}, {name: 'Mes modalités d’accueil'}]" @changeTab="changeStep"></EbTabs>
				
				<form @submit.prevent="doAction">
					<div v-if="infos && (page == 0 || ((isMobile  || isSmallScreen) && !isActiveTab))" id="panel-0" class="w75" role="tabpanel" tabindex="0" aria-labelledby="tab-0">
						<EbHeading level="h2" class="eb-box-heading">Ma présentation</EbHeading>
						
						<EbBanner :isActive="isBannerActive" :type="bannerType" :title="bannerTitle" :timestamp="bannerTimestamp">{{bannerContent}}</EbBanner>
						
						<EbTextarea type="text" label="Je me présente brièvement (1000 caractères maximum)" id="presentation" :rows="5" width="expand" v-model="infos.presentation.presentation" :maxcharacter="1000"></EbTextarea>
						<EbCheckbox label="Afficher mon âge" v-model="infos.presentation.afficherAge"></EbCheckbox>
						
						<div class="eb-button-group">
							<EbButton type="submit" @click="setAssmatInfo">Enregistrer</EbButton>
						</div>
					</div>
					
					<div v-if="infos && infos.coordonnees && (page == 1 || ((isMobile  || isSmallScreen) && !isActiveTab))" id="panel-1" class="w75" role="tabpanel" tabindex="0" aria-labelledby="tab-1">
						<EbHeading level="h2" class="eb-box-heading">Me contacter</EbHeading>
						
						<EbBanner :isActive="isBannerActive" :type="bannerType" :title="bannerTitle" :timestamp="bannerTimestamp">{{bannerContent}}</EbBanner>
						
						<fieldset>
							<legend>Je souhaite afficher sur ma fiche en ligne le(s) moyen(s) de contact suivant(s) :</legend>
              
              <EbDisclosure class="eb-form-group" v-model="infos.coordonnees.accepteContactCourriel" label="Courriel" isSwitch groupTag="div">
                <EbInput type="email" label="Mon courriel" inline v-model="infos.coordonnees.courriel" v-if="infos.coordonnees.accepteContactCourriel" required></EbInput>
              </EbDisclosure>
							<EbDisclosure class="eb-form-group" v-model="infos.coordonnees.accepteContactTelephonePortable" label="Téléphone portable" isSwitch groupTag="div">
								<EbInput type="tel" label="Mon numéro de portable" id="num-port" inline v-model="infos.coordonnees.numeroTelephonePortable" v-if="infos.coordonnees.accepteContactTelephonePortable" disabled></EbInput>
							</EbDisclosure>
							
							<EbDisclosure class="eb-form-group" v-model="infos.coordonnees.accepteContactTelephone" label="Téléphone fixe" isSwitch groupTag="div">
								<EbInput type="tel" label="Mon numéro de fixe" inline v-model="infos.coordonnees.numeroTelephoneFixe" v-if="infos.coordonnees.accepteContactTelephone" disabled></EbInput>
							</EbDisclosure>
              
							<div class="eb-exergue eb-lighter-blue-bgcolor">
								<p>Pour tout changement de numéro de téléphone (fixe ou portable), merci d'en informer votre PMI de rattachement : <a href="/mon-compte">Mon compte > onglet « Contacts »</a></p>
							</div>

						</fieldset>
						
						<EbTextarea label="Précisions sur les modalités de contact (horaires…) (1000 caractères maximum)" :rows="8" width="expand" v-model="infos.coordonnees.precisionsModalitesContact" :maxcharacter="1000"></EbTextarea>
						
						<div class="eb-button-group">
							<EbButton type="submit" @click="setAssmatInfo">Enregistrer</EbButton>
						</div>
					</div>
					
					<div v-if="infos && infos.presentation && (page == 2 || ((isMobile  || isSmallScreen) && !isActiveTab))" id="panel-2" class="w75" role="tabpanel" tabindex="0" aria-labelledby="tab-2">
						<EbHeading level="h2" class="eb-box-heading">Mes formations et compétences</EbHeading>
						
						<EbBanner :isActive="isBannerActive" :type="bannerType" :title="bannerTitle" :timestamp="bannerTimestamp">{{bannerContent}}</EbBanner>
						
						<EbDisclosure v-model="infos.presentation.premiersSecours" label="J’ai une initiation/formation aux premiers secours" isSwitch groupTag="div">
							<EbInput v-if="infos.presentation.premiersSecours" type="date" label="Année d’obtention :" inline v-model="infos.presentation.dateObtentionPremierSecours" :disabled="!infos.presentation.premiersSecours" required></EbInput>
						</EbDisclosure>
						
						<EbTextarea label="Précisions sur les formations que j’ai suivies, d’autres expériences professionnelles ou tout autre élément de mon profil susceptible d’intéresser les familles : (1000 caractères maximum)" :rows="8" width="expand" v-model="infos.presentation.formationsCompetences" :maxcharacter="1000"></EbTextarea>
						
						<div class="eb-button-group">
							<EbButton type="submit" @click="setAssmatInfo">Enregistrer</EbButton>
						</div>
					</div>
					
					<div v-if="modalites && (page == 3 || isActiveTab)" id="panel-3" class="w75" role="tabpanel" tabindex="0" aria-labelledby="tab-3">
						<EbHeading level="h2" class="eb-box-heading">Mes modalités d’accueil</EbHeading>
						
						<EbBanner :isActive="isBannerActive" :type="bannerType" :title="bannerTitle" :timestamp="bannerTimestamp">{{bannerContent}}</EbBanner>
						
						<fieldset>
							<legend>Sélectionner les modalités d'accueil que vous souhaitez afficher aux parents</legend>	
							<EbCheckbox label="Je suis non-fumeur / non-fumeuse" v-model="modalites.fumeur"></EbCheckbox>
							<EbCheckbox label="Je travaille le mercredi" v-model="modalites.travailMercredi"></EbCheckbox>
							<EbCheckbox label="Je possède des animaux" v-model="modalites.possedeAnimaux"></EbCheckbox>
							<EbCheckbox label="Je possède un espace extérieur" v-model="modalites.possedeEspaceExterieur"></EbCheckbox>
							<EbCheckbox label="Je possède un permis de conduire" v-model="modalites.possedePermisConduire"></EbCheckbox>
							<EbCheckbox label="Je propose des repas" v-model="modalites.proposeRepas"></EbCheckbox>
							<EbCheckbox label="J’accepte les enfants en situation de handicap" v-model="modalites.accepteEnfantHandicape"></EbCheckbox>
							<EbCheckbox label="J’accepte le temps partiel" v-model="modalites.accepteTempsPartiel"></EbCheckbox>
							<EbCheckbox label="J’accepte de faire des remplacements" v-model="modalites.accepteFaireRemplacements"></EbCheckbox>
							<EbCheckbox label="J’accepte les horaires atypiques" v-model="modalites.accepteHorairesAtypiques"></EbCheckbox>
						</fieldset>
						
						<EbTextarea label="Précisions sur mon mode de fonctionnement, les activités que je propose, la qualité de l'environnement dans lequel j'accueille les enfants... (1000 caractères maximum)" width="expand" v-model="modalites.precisionsModalitesAccueil" :maxcharacter="1000"></EbTextarea>
						<EbTextarea label="Besoins particuliers en terme de vacances ou d'horaires (1000 caractères maximum)" width="expand" v-model="modalites.precisionsHorairesConges" :maxcharacter="1000"></EbTextarea>
						
						<EbHeading level="h2" class="eb-box-heading">Mes tarifs</EbHeading>
						<EbTextarea label="Informations sur mes tarifs (salaire, horaire, frais d'entretien, indemnités de repas…) (1000 caractères maximum)" width="expand" v-model="modalites.tarifs" :maxcharacter="1000"></EbTextarea>
						
						<div class="eb-button-group">
							<EbButton type="submit" @click="setAssmatModalites">Enregistrer</EbButton>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "mesInfosParents",
	props: {
		home: Boolean,
	},
	data() {
		return {
			page: 0,
			infos: null,
			modalites: null,
			isActiveTab: false,
			isActiveIndex: 0,
			collapsed: true,
			errorGetInfos: false,
			errorGetModalites: false,
			errorSetInfos: false,
			errorSetModalites: false,
			successSetInfos: false,
			successSetModalites: false,
			publicProfileUrl: '',
			isBannerActive: false,
			bannerTimestamp: '',
			bannerType: null,
			bannerTitle: '',
			bannerContent: ''
		}
	},
	mounted() {
		this.getAssmatInfo(),
		this.publicProfileUrl = this.getPublicProfileLink()
	},
	computed: {
		isGetErrored: function() {
			return this.errorGetInfos || this.errorGetModalites
		},
		isSetErrored: function() {
			return this.errorSetInfos || this.errorSetModalites
		},
		isSetSuccess: function() {
			return this.successSetInfos || this.successSetModalites
		},
		presentation: function() {
			var howLong = 150
			return this.infos.presentation.presentation.length > howLong ? this.infos.presentation.presentation.slice(0, howLong-1) + '[…]': this.infos.presentation.presentation
		}
	},
	watch: {
		page: function() {
			if(this.page < 3) {
				this.isBannerActive = false
				this.getAssmatInfo()
			}
			else {
				this.getAssmatModalites()
			}
		}
	},
	methods: {
		getAssmatInfo: async function() {
			this.isBannerActive = false
			await this.$http.get("assmat/infos")
			.then(resp => {
				this.infos = resp.data
			})
			.catch(error => {
				this.isBannerActive = true
				this.bannerTimestamp = this.getTime()
				this.bannerType = 'error'
				this.bannerTitle = 'La récupération des informations a échoué'
				this.bannerContent = 'Une erreur est survenue, veuillez réessayer ultérieurement.'
			})
		},
		setAssmatInfo: async function(e) {
			this.isBannerActive = false
			this.bannerTimestamp = this.getTime()
			
			await this.$http.put("assmat/infos", {
				presentation: {
					afficherAge: this.infos.presentation.afficherAge,
					premiersSecours: this.infos.presentation.premiersSecours,
					dateObtentionPremierSecours: this.infos.presentation.dateObtentionPremierSecours,
					formationsCompetences: this.infos.presentation.formationsCompetences,
					presentation: this.infos.presentation.presentation,
				},
				coordonnees: {
					accepteContactCourriel: this.infos.coordonnees.accepteContactCourriel,
					accepteContactTelephone: this.infos.coordonnees.accepteContactTelephone,
					accepteContactTelephonePortable: this.infos.coordonnees.accepteContactTelephonePortable,
					courriel: this.infos.coordonnees.courriel,
					numeroTelephoneFixe: this.infos.coordonnees.numeroTelephoneFixe,
					numeroTelephonePortable: this.infos.coordonnees.numeroTelephonePortable,
					precisionsModalitesContact: this.infos.coordonnees.precisionsModalitesContact,
					telephoneListeRouge: this.infos.coordonnees.telephoneListeRouge,
				},
			})
			.then(resp => {
				this.isBannerActive = true
				this.bannerType = 'success'
				this.bannerTitle = 'L’enregistrement des informations a réussi'
				this.bannerContent = 'L’enregistrement des modifications a bien été pris en compte.'
			})
			.catch(error => {
				this.isBannerActive = true
				this.bannerType = 'error'
				this.bannerTitle = 'L’enregistrement des informations a échoué'
				this.bannerContent = 'Une erreur est survenue, veuillez vérifier votre saisie.'
			})
		},
		getAssmatModalites: async function() {
			this.isBannerActive = false
			await this.$http.get("assmat/modalites")
			.then(resp => {
				this.modalites = resp.data
			})
			.catch(error => {
				this.isBannerActive = true
				this.bannerTimestamp = this.getTime()
				this.bannerType = 'error'
				this.bannerTitle = 'La récupération des informations a échoué'
				this.bannerContent = 'Une erreur est survenue, veuillez réessayer ultérieurement.'
			})
		},
		setAssmatModalites: async function(e) {
			this.isBannerActive = false
			this.bannerTimestamp = this.getTime()
			await this.$http.put("assmat/modalites", {
				accepteEnfantHandicape: this.modalites.accepteEnfantHandicape,
				accepteFaireRemplacements: this.modalites.accepteFaireRemplacements,
				accepteHorairesAtypiques: this.modalites.accepteHorairesAtypiques,
				accepteTempsPartiel: this.modalites.accepteTempsPartiel,
				exerceDomicile: this.modalites.exerceDomicile,
				fumeur: this.modalites.fumeur,
				idAssmat: this.modalites.idAssmat,
				possedeAnimaux: this.modalites.possedeAnimaux,
				possedeEspaceExterieur: this.modalites.possedeEspaceExterieur,
				possedePermisConduire: this.modalites.possedePermisConduire,
				precisionsHorairesConges: this.modalites.precisionsHorairesConges,
				precisionsModalitesAccueil: this.modalites.precisionsModalitesAccueil,
				proposeRepas: this.modalites.proposeRepas,
				tarifs: this.modalites.tarifs,
				travailMercredi: this.modalites.travailMercredi,
			})
			.then(resp => {
				this.isBannerActive = true
				this.bannerType = 'success'
				this.bannerTitle = 'L’enregistrement des informations a réussi'
				this.bannerContent = 'L’enregistrement des modifications a bien été pris en compte.'
			})
			.catch(error => {
				this.isBannerActive = true
				this.bannerType = 'error'
				this.bannerTitle = 'L’enregistrement des informations a échoué'
				this.bannerContent = 'Une erreur est survenue, veuillez vérifier votre saisie.'
			})
			
		},
		toggleTab: function() {
			if (this.isActiveTab) {
				this.isActiveTab = false
				this.page = 0
			} else {
				this.isActiveTab = true
				this.page = 3
			}
		},
		toggleCollapse: function() {
			if (this.collapsed) {
				this.collapsed = false
			} else {
				this.collapsed = true
			}
		},
		resetErrorGet: function() {
			this.errorGetInfos = false
			this.errorGetModalites = false
		},
		resetErrorSet: function() {
			this.errorSetInfos = false
			this.errorSetModalites = false
		},
		resetSucessSet: function() {
			this.successSetInfos = false
			this.successSetModalites = false
		},
		doAction: function() {
			this.isBannerActive = false
			
			if(this.page!==3) {
				this.setAssmatInfo()
			}
			else {
				this.setAssmatModalites()
			}
		}
	},
}
</script>

<style scoped>
.eb-input-label:last-child {
	margin-bottom: 1.5rem !important;
}
.eb-card-collapsible {
  padding: 0;
}
</style>
